import { z } from 'zod';

/**
 * Query string の boolean 値を変換する。
 * GET リクエストでは boolean が文字列として送信されるため、
 * "true"/"false" を boolean に変換する。
 */
export const booleanFromQuery = z.union([z.boolean(), z.string()]).transform(v => typeof v === 'string' ? v === 'true' : v);
export function paginationQuerySchema<T extends z.ZodTypeAny>(orderFields: T) {
  return z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(2000).default(20),
    orderBy: orderFields.optional(),
    orderDirection: z.enum(['asc', 'desc']).default('asc')
  });
}
export function paginatedSchema<T extends z.ZodTypeAny>(itemSchema: T) {
  return z.object({
    items: z.array(itemSchema),
    length: z.number(),
    count: z.number(),
    page: z.number(),
    maxPage: z.number()
  });
}

/**
 * `pageSize === 0` を「全件返す」と解釈するページサイズ（既定なし・optional）。
 * BE の `pageSizeAllowingAllSchema` と揃える。
 */
export function pageSizeAllowingAllSchema(p?: {
  max?: number;
}) {
  return z.coerce.number().int().min(0).max(p?.max ?? 2000).optional();
}